import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Paper, Typography, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import ForumIcon from '@mui/icons-material/Forum';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import PetsIcon from '@mui/icons-material/Pets';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { colors } from '../../styles/theme.js';

/**
 * Rahmen des Settings-Bereichs: Menue links, Inhalt rechts.
 *
 * Die Bereiche sind eigene Routen (`/admin/settings/slack`), damit ein Reload
 * oder ein geteilter Link im richtigen Abschnitt landet statt immer auf "Allgemein".
 */
const sections = [
  { label: 'Allgemein', path: '/admin/settings/general', icon: <SettingsIcon fontSize="small" />, hint: 'Datenbank · Entwicklermodus' },
  { label: 'Slack Config', path: '/admin/settings/slack', icon: <ForumIcon fontSize="small" />, hint: 'Kanäle · Webhooks · Test' },
  { label: 'Key Config', path: '/admin/settings/keys', icon: <VpnKeyIcon fontSize="small" />, hint: 'Key/Value-Einstellungen' },
  { label: 'Watchdog', path: '/admin/settings/watchdog', icon: <PetsIcon fontSize="small" />, hint: 'Auswertungs-Template je Datenbank' },
  { label: 'Cron Jobs', path: '/admin/settings/cron-jobs', icon: <ScheduleIcon fontSize="small" />, hint: 'Nachtlauf · Wächter · Zeitpläne' },
];

export default function SettingsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>System Settings</Typography>

      <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start', flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
        <Paper
          elevation={0}
          sx={{
            border: `1px solid ${colors.silver}`,
            width: { xs: '100%', md: 240 },
            flexShrink: 0,
            position: { md: 'sticky' },
            top: { md: 88 },
          }}
        >
          <List disablePadding>
            {sections.map((s) => {
              const active = location.pathname.startsWith(s.path);
              return (
                <ListItemButton
                  key={s.path}
                  selected={active}
                  onClick={() => navigate(s.path)}
                  sx={{
                    py: 1.5,
                    borderLeft: `3px solid ${active ? colors.lime : 'transparent'}`,
                    '&.Mui-selected': { bgcolor: 'rgba(206, 255, 0, 0.10)' },
                    '&.Mui-selected:hover': { bgcolor: 'rgba(206, 255, 0, 0.16)' },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36, color: active ? colors.black : colors.black60 }}>
                    {s.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={s.label}
                    secondary={s.hint}
                    primaryTypographyProps={{ variant: 'body2', fontWeight: active ? 600 : 500 }}
                    secondaryTypographyProps={{ variant: 'caption', sx: { color: colors.black60 } }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Paper>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
